import React, { useState } from 'react'
import axios from "axios"
import "./verify-banner.css"
import constants from "../../constants"
const {SOURCE_IP} = constants()

type VerifyBannerProps = {
    email: string;
    setToken: CallableFunction;
    token: string;
  }

export default function VerifyBanner({email, setToken, token} : VerifyBannerProps) {
    const [bannerMsg, setBannerMsg] = useState("You still need to verify your account. Click this message to send a verification link to your email.")
    const [verifySent, setVerifySent] = useState(false);
    const sendToken = () => {
        if (!verifySent) {
        setBannerMsg("Sending your verification email now...")
        axios({
            method: "POST",
            url: SOURCE_IP + "/submitverification",
            headers: {
              email: email,
            }
          }).then((response) => {
            if (response.data.access_token) {
              setToken(response.data.access_token)
            }
            setVerifySent(true);
            setBannerMsg("Verification email sent!")
          }).catch((error) => {
            if (error.response) {
              //console.log(error.response)
              //console.log(error.response.status)
              //console.log(error.response.headers)
              setBannerMsg("There was an error sending your verification email. Please try again.")
            }
          })
        }
    }
  return (
        <div className='banner' onClick={() => sendToken()}>
            {bannerMsg}
        </div>
  )
}